import { render } from "./IconFace.vue?vue&type=template&id=0e0202c5"
import script from "./IconFace.vue?vue&type=script&lang=js"
export * from "./IconFace.vue?vue&type=script&lang=js"
script.render = render

export default script